/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConnectFinishIn,
  ConnectStartOut,
  DepositDispositionIn,
  DepositDispositionOut,
  DepositDispositionsOut,
  HTTPValidationError,
  ListPaymentsParams,
  PaginatedPaymentOut,
  PaymentIn,
  PaymentOut,
  PaymentSettingsIn,
  PaymentSettingsOut,
  ReversePaymentIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listPaymentsResponse200 = {
  data: PaginatedPaymentOut
  status: 200
}

export type listPaymentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPaymentsResponseSuccess = (listPaymentsResponse200) & {
  headers: Headers;
};
export type listPaymentsResponseError = (listPaymentsResponse422) & {
  headers: Headers;
};

export type listPaymentsResponse = (listPaymentsResponseSuccess | listPaymentsResponseError)

export const getListPaymentsUrl = (params?: ListPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments?${stringifiedParams}` : `/api/payments`
}

/**
 * @summary List Payments
 */
export const listPayments = async (params?: ListPaymentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listPaymentsResponse> => {

  return apiFetch<listPaymentsResponse>(getListPaymentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPaymentsQueryKey = (params?: ListPaymentsParams,) => {
    return [
    `/api/payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listPayments>>, TError = HTTPValidationError>(params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayments>>> = ({ signal }) => listPayments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayments>>>
export type ListPaymentsQueryError = HTTPValidationError


export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = HTTPValidationError>(
 params: undefined |  ListPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayments>>,
          TError,
          Awaited<ReturnType<typeof listPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = HTTPValidationError>(
 params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayments>>,
          TError,
          Awaited<ReturnType<typeof listPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = HTTPValidationError>(
 params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Payments
 */

export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = HTTPValidationError>(
 params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordPaymentResponse201 = {
  data: PaymentOut
  status: 201
}

export type recordPaymentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type recordPaymentResponseSuccess = (recordPaymentResponse201) & {
  headers: Headers;
};
export type recordPaymentResponseError = (recordPaymentResponse422) & {
  headers: Headers;
};

export type recordPaymentResponse = (recordPaymentResponseSuccess | recordPaymentResponseError)

export const getRecordPaymentUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/payments`
}

/**
 * @summary Record Payment
 */
export const recordPayment = async (leaseId: number,
    paymentIn: PaymentIn, options?: Parameters<typeof apiFetch>[1]): Promise<recordPaymentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<recordPaymentResponse>(getRecordPaymentUrl(leaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentIn)
  }
);}





export const getRecordPaymentMutationKey = () => ['recordPayment'] as const;

export const getRecordPaymentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,RecordPaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,RecordPaymentMutationVariables, TContext> => {

const mutationKey = getRecordPaymentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPayment>>, RecordPaymentMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  recordPayment(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordPayment>>>
    export type RecordPaymentMutationBody = PaymentIn
    export type RecordPaymentMutationError = HTTPValidationError
    export type RecordPaymentMutationVariables = {leaseId: number;data: PaymentIn}

    /**
 * @summary Record Payment
 */
export const useRecordPayment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,RecordPaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordPayment>>,
        TError,
        RecordPaymentMutationVariables,
        TContext
      > => {
      return useMutation(getRecordPaymentMutationOptions(options), queryClient);
    }
    export type reversePaymentResponse200 = {
  data: PaymentOut
  status: 200
}

export type reversePaymentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reversePaymentResponseSuccess = (reversePaymentResponse200) & {
  headers: Headers;
};
export type reversePaymentResponseError = (reversePaymentResponse422) & {
  headers: Headers;
};

export type reversePaymentResponse = (reversePaymentResponseSuccess | reversePaymentResponseError)

export const getReversePaymentUrl = (paymentId: number,) => {




  return `/api/payments/${paymentId}/reverse`
}

/**
 * @summary Reverse Payment
 */
export const reversePayment = async (paymentId: number,
    reversePaymentIn: ReversePaymentIn, options?: Parameters<typeof apiFetch>[1]): Promise<reversePaymentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<reversePaymentResponse>(getReversePaymentUrl(paymentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reversePaymentIn)
  }
);}





export const getReversePaymentMutationKey = () => ['reversePayment'] as const;

export const getReversePaymentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reversePayment>>, TError,ReversePaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reversePayment>>, TError,ReversePaymentMutationVariables, TContext> => {

const mutationKey = getReversePaymentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reversePayment>>, ReversePaymentMutationVariables> = (props) => {
          const {paymentId,data} = props ?? {};

          return  reversePayment(paymentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReversePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof reversePayment>>>
    export type ReversePaymentMutationBody = ReversePaymentIn
    export type ReversePaymentMutationError = HTTPValidationError
    export type ReversePaymentMutationVariables = {paymentId: number;data: ReversePaymentIn}

    /**
 * @summary Reverse Payment
 */
export const useReversePayment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reversePayment>>, TError,ReversePaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reversePayment>>,
        TError,
        ReversePaymentMutationVariables,
        TContext
      > => {
      return useMutation(getReversePaymentMutationOptions(options), queryClient);
    }
    export type listDepositDispositionsResponse200 = {
  data: DepositDispositionsOut
  status: 200
}

export type listDepositDispositionsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listDepositDispositionsResponseSuccess = (listDepositDispositionsResponse200) & {
  headers: Headers;
};
export type listDepositDispositionsResponseError = (listDepositDispositionsResponse422) & {
  headers: Headers;
};

export type listDepositDispositionsResponse = (listDepositDispositionsResponseSuccess | listDepositDispositionsResponseError)

export const getListDepositDispositionsUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/deposit-dispositions`
}

/**
 * @summary List Deposit Dispositions
 */
export const listDepositDispositions = async (leaseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<listDepositDispositionsResponse> => {

  return apiFetch<listDepositDispositionsResponse>(getListDepositDispositionsUrl(leaseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDepositDispositionsQueryKey = (leaseId: number,) => {
    return [
    `/api/leases/${leaseId}/deposit-dispositions`
    ] as const;
    }


export const getListDepositDispositionsQueryOptions = <TData = Awaited<ReturnType<typeof listDepositDispositions>>, TError = HTTPValidationError>(leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepositDispositions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDepositDispositionsQueryKey(leaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDepositDispositions>>> = ({ signal }) => listDepositDispositions(leaseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leaseId !== null && leaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDepositDispositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDepositDispositionsQueryResult = NonNullable<Awaited<ReturnType<typeof listDepositDispositions>>>
export type ListDepositDispositionsQueryError = HTTPValidationError


export function useListDepositDispositions<TData = Awaited<ReturnType<typeof listDepositDispositions>>, TError = HTTPValidationError>(
 leaseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepositDispositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDepositDispositions>>,
          TError,
          Awaited<ReturnType<typeof listDepositDispositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDepositDispositions<TData = Awaited<ReturnType<typeof listDepositDispositions>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepositDispositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDepositDispositions>>,
          TError,
          Awaited<ReturnType<typeof listDepositDispositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDepositDispositions<TData = Awaited<ReturnType<typeof listDepositDispositions>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepositDispositions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Deposit Dispositions
 */

export function useListDepositDispositions<TData = Awaited<ReturnType<typeof listDepositDispositions>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepositDispositions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDepositDispositionsQueryOptions(leaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordDepositDispositionResponse201 = {
  data: DepositDispositionOut
  status: 201
}

export type recordDepositDispositionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type recordDepositDispositionResponseSuccess = (recordDepositDispositionResponse201) & {
  headers: Headers;
};
export type recordDepositDispositionResponseError = (recordDepositDispositionResponse422) & {
  headers: Headers;
};

export type recordDepositDispositionResponse = (recordDepositDispositionResponseSuccess | recordDepositDispositionResponseError)

export const getRecordDepositDispositionUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/deposit-dispositions`
}

/**
 * @summary Record Deposit Disposition
 */
export const recordDepositDisposition = async (leaseId: number,
    depositDispositionIn: DepositDispositionIn, options?: Parameters<typeof apiFetch>[1]): Promise<recordDepositDispositionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<recordDepositDispositionResponse>(getRecordDepositDispositionUrl(leaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(depositDispositionIn)
  }
);}





export const getRecordDepositDispositionMutationKey = () => ['recordDepositDisposition'] as const;

export const getRecordDepositDispositionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDepositDisposition>>, TError,RecordDepositDispositionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordDepositDisposition>>, TError,RecordDepositDispositionMutationVariables, TContext> => {

const mutationKey = getRecordDepositDispositionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordDepositDisposition>>, RecordDepositDispositionMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  recordDepositDisposition(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordDepositDispositionMutationResult = NonNullable<Awaited<ReturnType<typeof recordDepositDisposition>>>
    export type RecordDepositDispositionMutationBody = DepositDispositionIn
    export type RecordDepositDispositionMutationError = HTTPValidationError
    export type RecordDepositDispositionMutationVariables = {leaseId: number;data: DepositDispositionIn}

    /**
 * @summary Record Deposit Disposition
 */
export const useRecordDepositDisposition = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDepositDisposition>>, TError,RecordDepositDispositionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordDepositDisposition>>,
        TError,
        RecordDepositDispositionMutationVariables,
        TContext
      > => {
      return useMutation(getRecordDepositDispositionMutationOptions(options), queryClient);
    }
    export type getDepositLetterResponse200 = {
  data: Blob
  status: 200
}

export type getDepositLetterResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getDepositLetterResponseSuccess = (getDepositLetterResponse200) & {
  headers: Headers;
};
export type getDepositLetterResponseError = (getDepositLetterResponse422) & {
  headers: Headers;
};

export type getDepositLetterResponse = (getDepositLetterResponseSuccess | getDepositLetterResponseError)

export const getGetDepositLetterUrl = (dispositionId: number,) => {




  return `/api/deposit-dispositions/${dispositionId}/letter`
}

/**
 * @summary Get Deposit Letter
 */
export const getDepositLetter = async (dispositionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getDepositLetterResponse> => {

  return apiFetch<getDepositLetterResponse>(getGetDepositLetterUrl(dispositionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDepositLetterQueryKey = (dispositionId: number,) => {
    return [
    `/api/deposit-dispositions/${dispositionId}/letter`
    ] as const;
    }


export const getGetDepositLetterQueryOptions = <TData = Awaited<ReturnType<typeof getDepositLetter>>, TError = HTTPValidationError>(dispositionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositLetter>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepositLetterQueryKey(dispositionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepositLetter>>> = ({ signal }) => getDepositLetter(dispositionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: dispositionId !== null && dispositionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepositLetter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepositLetterQueryResult = NonNullable<Awaited<ReturnType<typeof getDepositLetter>>>
export type GetDepositLetterQueryError = HTTPValidationError


export function useGetDepositLetter<TData = Awaited<ReturnType<typeof getDepositLetter>>, TError = HTTPValidationError>(
 dispositionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositLetter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepositLetter>>,
          TError,
          Awaited<ReturnType<typeof getDepositLetter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepositLetter<TData = Awaited<ReturnType<typeof getDepositLetter>>, TError = HTTPValidationError>(
 dispositionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositLetter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepositLetter>>,
          TError,
          Awaited<ReturnType<typeof getDepositLetter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepositLetter<TData = Awaited<ReturnType<typeof getDepositLetter>>, TError = HTTPValidationError>(
 dispositionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositLetter>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Deposit Letter
 */

export function useGetDepositLetter<TData = Awaited<ReturnType<typeof getDepositLetter>>, TError = HTTPValidationError>(
 dispositionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositLetter>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepositLetterQueryOptions(dispositionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type reverseDepositDispositionResponse200 = {
  data: DepositDispositionOut
  status: 200
}

export type reverseDepositDispositionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reverseDepositDispositionResponseSuccess = (reverseDepositDispositionResponse200) & {
  headers: Headers;
};
export type reverseDepositDispositionResponseError = (reverseDepositDispositionResponse422) & {
  headers: Headers;
};

export type reverseDepositDispositionResponse = (reverseDepositDispositionResponseSuccess | reverseDepositDispositionResponseError)

export const getReverseDepositDispositionUrl = (dispositionId: number,) => {




  return `/api/deposit-dispositions/${dispositionId}/reverse`
}

/**
 * @summary Reverse Deposit Disposition
 */
export const reverseDepositDisposition = async (dispositionId: number,
    reversePaymentIn: ReversePaymentIn, options?: Parameters<typeof apiFetch>[1]): Promise<reverseDepositDispositionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<reverseDepositDispositionResponse>(getReverseDepositDispositionUrl(dispositionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reversePaymentIn)
  }
);}





export const getReverseDepositDispositionMutationKey = () => ['reverseDepositDisposition'] as const;

export const getReverseDepositDispositionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseDepositDisposition>>, TError,ReverseDepositDispositionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reverseDepositDisposition>>, TError,ReverseDepositDispositionMutationVariables, TContext> => {

const mutationKey = getReverseDepositDispositionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reverseDepositDisposition>>, ReverseDepositDispositionMutationVariables> = (props) => {
          const {dispositionId,data} = props ?? {};

          return  reverseDepositDisposition(dispositionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReverseDepositDispositionMutationResult = NonNullable<Awaited<ReturnType<typeof reverseDepositDisposition>>>
    export type ReverseDepositDispositionMutationBody = ReversePaymentIn
    export type ReverseDepositDispositionMutationError = HTTPValidationError
    export type ReverseDepositDispositionMutationVariables = {dispositionId: number;data: ReversePaymentIn}

    /**
 * @summary Reverse Deposit Disposition
 */
export const useReverseDepositDisposition = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseDepositDisposition>>, TError,ReverseDepositDispositionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reverseDepositDisposition>>,
        TError,
        ReverseDepositDispositionMutationVariables,
        TContext
      > => {
      return useMutation(getReverseDepositDispositionMutationOptions(options), queryClient);
    }
    export type getPaymentReceiptResponse200 = {
  data: void
  status: 200
}

export type getPaymentReceiptResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPaymentReceiptResponseSuccess = (getPaymentReceiptResponse200) & {
  headers: Headers;
};
export type getPaymentReceiptResponseError = (getPaymentReceiptResponse422) & {
  headers: Headers;
};

export type getPaymentReceiptResponse = (getPaymentReceiptResponseSuccess | getPaymentReceiptResponseError)

export const getGetPaymentReceiptUrl = (paymentId: number,) => {




  return `/api/payments/${paymentId}/receipt`
}

/**
 * @summary Get Payment Receipt
 */
export const getPaymentReceipt = async (paymentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPaymentReceiptResponse> => {

  return apiFetch<getPaymentReceiptResponse>(getGetPaymentReceiptUrl(paymentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentReceiptQueryKey = (paymentId: number,) => {
    return [
    `/api/payments/${paymentId}/receipt`
    ] as const;
    }


export const getGetPaymentReceiptQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentReceipt>>, TError = HTTPValidationError>(paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentReceipt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentReceiptQueryKey(paymentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentReceipt>>> = ({ signal }) => getPaymentReceipt(paymentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paymentId !== null && paymentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentReceipt>>>
export type GetPaymentReceiptQueryError = HTTPValidationError


export function useGetPaymentReceipt<TData = Awaited<ReturnType<typeof getPaymentReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentReceipt>>,
          TError,
          Awaited<ReturnType<typeof getPaymentReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentReceipt<TData = Awaited<ReturnType<typeof getPaymentReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentReceipt>>,
          TError,
          Awaited<ReturnType<typeof getPaymentReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentReceipt<TData = Awaited<ReturnType<typeof getPaymentReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentReceipt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Payment Receipt
 */

export function useGetPaymentReceipt<TData = Awaited<ReturnType<typeof getPaymentReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentReceipt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentReceiptQueryOptions(paymentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPaymentSettingsResponse200 = {
  data: PaymentSettingsOut
  status: 200
}

export type getPaymentSettingsResponseSuccess = (getPaymentSettingsResponse200) & {
  headers: Headers;
};
;

export type getPaymentSettingsResponse = (getPaymentSettingsResponseSuccess)

export const getGetPaymentSettingsUrl = () => {




  return `/api/orgs/current/payment-settings`
}

/**
 * @summary Get Payment Settings
 */
export const getPaymentSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPaymentSettingsResponse> => {

  return apiFetch<getPaymentSettingsResponse>(getGetPaymentSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentSettingsQueryKey = () => {
    return [
    `/api/orgs/current/payment-settings`
    ] as const;
    }


export const getGetPaymentSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentSettings>>> = ({ signal }) => getPaymentSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentSettings>>>
export type GetPaymentSettingsQueryError = unknown


export function useGetPaymentSettings<TData = Awaited<ReturnType<typeof getPaymentSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentSettings>>,
          TError,
          Awaited<ReturnType<typeof getPaymentSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentSettings<TData = Awaited<ReturnType<typeof getPaymentSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentSettings>>,
          TError,
          Awaited<ReturnType<typeof getPaymentSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentSettings<TData = Awaited<ReturnType<typeof getPaymentSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Payment Settings
 */

export function useGetPaymentSettings<TData = Awaited<ReturnType<typeof getPaymentSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updatePaymentSettingsResponse200 = {
  data: PaymentSettingsOut
  status: 200
}

export type updatePaymentSettingsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updatePaymentSettingsResponseSuccess = (updatePaymentSettingsResponse200) & {
  headers: Headers;
};
export type updatePaymentSettingsResponseError = (updatePaymentSettingsResponse422) & {
  headers: Headers;
};

export type updatePaymentSettingsResponse = (updatePaymentSettingsResponseSuccess | updatePaymentSettingsResponseError)

export const getUpdatePaymentSettingsUrl = () => {




  return `/api/orgs/current/payment-settings`
}

/**
 * @summary Update Payment Settings
 */
export const updatePaymentSettings = async (paymentSettingsIn: PaymentSettingsIn, options?: Parameters<typeof apiFetch>[1]): Promise<updatePaymentSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updatePaymentSettingsResponse>(getUpdatePaymentSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentSettingsIn)
  }
);}





export const getUpdatePaymentSettingsMutationKey = () => ['updatePaymentSettings'] as const;

export const getUpdatePaymentSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentSettings>>, TError,UpdatePaymentSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentSettings>>, TError,UpdatePaymentSettingsMutationVariables, TContext> => {

const mutationKey = getUpdatePaymentSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentSettings>>, UpdatePaymentSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePaymentSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentSettings>>>
    export type UpdatePaymentSettingsMutationBody = PaymentSettingsIn
    export type UpdatePaymentSettingsMutationError = HTTPValidationError
    export type UpdatePaymentSettingsMutationVariables = {data: PaymentSettingsIn}

    /**
 * @summary Update Payment Settings
 */
export const useUpdatePaymentSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentSettings>>, TError,UpdatePaymentSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentSettings>>,
        TError,
        UpdatePaymentSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePaymentSettingsMutationOptions(options), queryClient);
    }
    export type startStripeConnectResponse200 = {
  data: ConnectStartOut
  status: 200
}

export type startStripeConnectResponseSuccess = (startStripeConnectResponse200) & {
  headers: Headers;
};
;

export type startStripeConnectResponse = (startStripeConnectResponseSuccess)

export const getStartStripeConnectUrl = () => {




  return `/api/orgs/current/payment-settings/connect`
}

/**
 * @summary Start Stripe Connect
 */
export const startStripeConnect = async ( options?: Parameters<typeof apiFetch>[1]): Promise<startStripeConnectResponse> => {

  return apiFetch<startStripeConnectResponse>(getStartStripeConnectUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartStripeConnectMutationKey = () => ['startStripeConnect'] as const;

export const getStartStripeConnectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startStripeConnect>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startStripeConnect>>, TError,void, TContext> => {

const mutationKey = getStartStripeConnectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startStripeConnect>>, void> = () => {


          return  startStripeConnect(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartStripeConnectMutationResult = NonNullable<Awaited<ReturnType<typeof startStripeConnect>>>

    export type StartStripeConnectMutationError = unknown


    /**
 * @summary Start Stripe Connect
 */
export const useStartStripeConnect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startStripeConnect>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startStripeConnect>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartStripeConnectMutationOptions(options), queryClient);
    }
    export type finishStripeConnectResponse200 = {
  data: PaymentSettingsOut
  status: 200
}

export type finishStripeConnectResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type finishStripeConnectResponseSuccess = (finishStripeConnectResponse200) & {
  headers: Headers;
};
export type finishStripeConnectResponseError = (finishStripeConnectResponse422) & {
  headers: Headers;
};

export type finishStripeConnectResponse = (finishStripeConnectResponseSuccess | finishStripeConnectResponseError)

export const getFinishStripeConnectUrl = () => {




  return `/api/orgs/current/payment-settings/connect/finish`
}

/**
 * @summary Finish Stripe Connect
 */
export const finishStripeConnect = async (connectFinishIn: ConnectFinishIn, options?: Parameters<typeof apiFetch>[1]): Promise<finishStripeConnectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<finishStripeConnectResponse>(getFinishStripeConnectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(connectFinishIn)
  }
);}





export const getFinishStripeConnectMutationKey = () => ['finishStripeConnect'] as const;

export const getFinishStripeConnectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishStripeConnect>>, TError,FinishStripeConnectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finishStripeConnect>>, TError,FinishStripeConnectMutationVariables, TContext> => {

const mutationKey = getFinishStripeConnectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishStripeConnect>>, FinishStripeConnectMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  finishStripeConnect(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishStripeConnectMutationResult = NonNullable<Awaited<ReturnType<typeof finishStripeConnect>>>
    export type FinishStripeConnectMutationBody = ConnectFinishIn
    export type FinishStripeConnectMutationError = HTTPValidationError
    export type FinishStripeConnectMutationVariables = {data: ConnectFinishIn}

    /**
 * @summary Finish Stripe Connect
 */
export const useFinishStripeConnect = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishStripeConnect>>, TError,FinishStripeConnectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishStripeConnect>>,
        TError,
        FinishStripeConnectMutationVariables,
        TContext
      > => {
      return useMutation(getFinishStripeConnectMutationOptions(options), queryClient);
    }
    export type disconnectStripeResponse200 = {
  data: PaymentSettingsOut
  status: 200
}

export type disconnectStripeResponseSuccess = (disconnectStripeResponse200) & {
  headers: Headers;
};
;

export type disconnectStripeResponse = (disconnectStripeResponseSuccess)

export const getDisconnectStripeUrl = () => {




  return `/api/orgs/current/payment-settings/disconnect`
}

/**
 * @summary Disconnect Stripe
 */
export const disconnectStripe = async ( options?: Parameters<typeof apiFetch>[1]): Promise<disconnectStripeResponse> => {

  return apiFetch<disconnectStripeResponse>(getDisconnectStripeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectStripeMutationKey = () => ['disconnectStripe'] as const;

export const getDisconnectStripeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectStripe>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectStripe>>, TError,void, TContext> => {

const mutationKey = getDisconnectStripeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectStripe>>, void> = () => {


          return  disconnectStripe(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectStripeMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectStripe>>>

    export type DisconnectStripeMutationError = unknown


    /**
 * @summary Disconnect Stripe
 */
export const useDisconnectStripe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectStripe>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectStripe>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectStripeMutationOptions(options), queryClient);
    }
